/*       */

import { gql } from '@apollo/client';

export default gql`
    query pipelineAutocompleteQuery($startIndex: Int, $stopIndex: Int, $filterBy: [JSON], $orderBy: [JSON], $excludeBy: [JSON]) {
        result: versionedEntities(
            type: "iot_pipeline"
            startIndex: $startIndex
            stopIndex: $stopIndex
            filterBy: $filterBy
            orderBy: $orderBy
            excludeBy: $excludeBy
        ) {
            id
            type
            name
            image
            lastVersion {
                id
                primary
            }
        }
    }
`;
